import { LocalSearchSort } from '../../nav-my-playlist-categories/utils';
import { SortOption } from '../../sort-options-sheet/sort-options-sheet';
import BPMIcons from '../bpm-icons/bpm-icons';
import PrimaryPageTitle from '../primary-page-title/primary-page-title';
import { SearchInput } from '../search-input/search-input';
import { ShareURL } from '../share-url/share-url';
import { SortControl } from '../sort-control/sort-control';
import styles from './page-header.module.css';

interface PageHeaderProps {
    title: string;
    handleAdd?: () => void;
    searchPlaceholder?: string;
    searchTerm?: string;
    setSearchTerm?: (text: string) => void;
    onSort?: (type: LocalSearchSort) => void;
    selectedSortType?: LocalSearchSort;
    sortOptions?: SortOption<LocalSearchSort>[];
    sharePage?: boolean;
}

export const LOCAL_SORT_OPTIONS: SortOption<LocalSearchSort>[] = [
    { actionType: 'most_recent', label: 'Most Recent' },
    { actionType: 'title_asc', label: 'Title (a-z)' },
    { actionType: 'title_desc', label: 'Title (z-a)' },
];

export function PageHeader({ title, handleAdd, searchPlaceholder, searchTerm, setSearchTerm, onSort, selectedSortType, sortOptions = LOCAL_SORT_OPTIONS, sharePage = false }: PageHeaderProps) {
    return (
        <div className={styles['page-header']}>
            <div className={styles['page-header--main-container']}>
                <PrimaryPageTitle title={title} noPadding />
                <div className={styles['page-header--buttons']}>
                    {handleAdd ?
                        (
                            <button type="button" onClick={handleAdd}>
                                <BPMIcons.PlusIcon />
                            </button>
                        ) : null}
                    {sharePage ? (<ShareURL currentUrl />) : null}
                    {onSort ?
                        (
                            <SortControl selectedSortType={selectedSortType} sortOptions={sortOptions} onSort={onSort} />
                        ) : null}
                </div>
            </div>
            {searchTerm !== undefined && setSearchTerm ?
                (
                    <div className={styles['page-header--search']}>
                        <SearchInput
                            placeholder={searchPlaceholder || 'Search'}
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                            }}
                            onClear={() => setSearchTerm('')}
                        />
                    </div>
                ) : null}
        </div>
    );
}
